<template>
  <v-container fluid fill-height>
    <v-layout row align-center fill-height>
      <v-flex>

        <v-card style="max-width: 480px; margin: 0 auto; border-radius: 5px;" color="white" class="px-5 py-5 elevation-16">
          <img src="@/assets/logoStructube.png">
          <v-form ref="loginForm" class="mt-2">
            <v-text-field
              
              type="text"
              v-model="email"
              label="Email"
              :rules="emailRules"
              required
            />
            <v-text-field v-if="!isHidden"

              type="password"
              v-model="password"
              label="Password"
              :rules="passwordRules"
              required
            />
            <v-btn v-if="!isHidden" large type="submit" class="mx-0 mt-3 mb-0 elevation-0"
              style="width: 100%;"
             @click="submitLogin(email, password, $event)">
              Sign in
            </v-btn>
            <v-btn v-if="!isHidden" flat type="submit" class="mx-0 mt-3 mb-0 elevation-0"
              @click="isHidden = true">
              Forgot password?
            </v-btn>
            <v-btn v-if="isHidden" large type="submit" class="mx-0 mt-3 mb-0 elevation-0"
              style="width: 100%;"
              @click="sendForgotPasswordEmail(email,$event)">
              Submit
            </v-btn>
          </v-form>
        </v-card>
      </v-flex>
      <v-snackbar
        v-model="snackbar.show"
        :timeout="10000"
        top
        auto-height
        right
        :color="snackbar.color"
      >
        <div class="text-xs-left">{{ snackbar.message }}</div>
        <div>
          <v-btn
            dark
            flat
            @click="snackbar = false"
            justify-end
          >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import firebase from 'firebase/app';
import 'firebase/auth'
import { LOGIN,RESET_PASS } from "@/store/actions.type";
export default {
  name: "login",
  data() {
    return {
      snackbar: {
        show: false,
        message: null,
        color: null
      },
      email: null,
      password: null,
      emailRules: [
         v => !!v || 'E-mail is required',
         v => /.+@.+/.test(v) || 'E-mail must be valid'
       ],
      passwordRules: [
        v => !!v || 'Password is required'
      ],
      isHidden: false,
    };
  },
  methods: {
    submitLogin(email, password, event) {
      event.preventDefault()
      if (this.$refs.loginForm.validate()) {
        this.$store
          .dispatch(LOGIN, {email, password} )
          .then(() => this.$router.push({ name: "home" }))
          .catch(() => {
            this.snackbar = {
              message: this.errors,
              color: 'error',
              show: true
              }
            //this.$data.snackbar = true
          });
      }
    },
    sendForgotPasswordEmail(email,event) {
      event.preventDefault()
      if (this.$refs.loginForm.validate()) {
        this.$store
          .dispatch(RESET_PASS,{email})
          .then(() => {
            this.snackbar = {
              message: 'Email sent',
              color: null,
              show: true
            }         
            //this.$data.snackbar = true   
            this.$router.push({ name: "login" })
          })
          .catch(() => {
            this.snackbar = {
              message: this.errors,
              color: 'error',
              show: true
            }
            //this.$data.snackbar = true
          });
      }
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    })
  }
};
</script>
